module.exports = __webpack_public_path__ + "img/logo_light.d1750af4.png";